export const MAKE_ADMIN = '@@session/MAKE_ADMIN'
export const END_SESSION = '@@session/END_SESSION'
export const SET_CONNECTED = '@@session/SET_CONNECTED'
export const SET_DOMAIN = '@@session/SET_DOMAIN'
export const SET_SUBSCRIBED = '@@session/SET_SUBSCRIBED'
export const SET_EDITOR = '@@session/SET_EDITOR'
export const SET_USERS = '@@session/SET_USERS'
export const SET_VNC_DETAILS = '@@session/SET_VNC_DETAILS'
export const SET_PERCENT = '@@session/SET_PERCENT'

export interface SessionState {
	readonly isAdmin: boolean
	readonly domain: string
	readonly url: string
	readonly driveItemId: string
	readonly name: string
	readonly channelId: string
	readonly qr: string
	readonly code: string
	readonly connected: boolean
	readonly ended: boolean
	readonly fileEditor: string
	readonly username: string
	readonly password: string
	readonly users: LitbUser[]
	readonly percent: number
	readonly status: string
}

export interface LitbUser {
	userId: string
	displayName: string
	isConnected: boolean
}

export interface SetIsAdmin {
	type: typeof MAKE_ADMIN
	payload: boolean
}

export interface SetUsers {
	type: typeof SET_USERS
	payload: LitbUser[]
}

export interface EndSession {
	type: typeof END_SESSION
}

export interface SetConnected {
	type: typeof SET_CONNECTED
	payload: boolean
}

export interface SetDomain {
	type: typeof SET_DOMAIN
	payload: string
}

export interface SetPercent {
	type: typeof SET_PERCENT
	payload: { percent: number; status: string }
}

export interface SubscribedState {
	driveItemId: string
	channelId: string
	fileName: string
	userId: string
	qr: string
	url: string
	ws: string
	isAdmin: boolean
	code: string
	username: string
	password: string
}

export interface SetSubscribed {
	type: typeof SET_SUBSCRIBED
	payload: SubscribedState
}

export interface SetEditor {
	type: typeof SET_EDITOR
	payload: string
}

export interface SetVNCDetails {
	type: typeof SET_VNC_DETAILS
	payload: { username: string; password: string }
}

export type SessionActionTypes = SetIsAdmin | EndSession | SetConnected | SetDomain | SetSubscribed | SetEditor | SetUsers | SetVNCDetails | SetPercent
